export default __webpack_public_path__ + "static/media/cross-10.42d8abd7.svg";